<div *ngIf="vo$ | async; let vo" class="subscription-internal-metadata">
	<form
		*ngIf="!vo.isInViewMode"
		[formGroup]="internalMetadataForm.form"
		class="subscription-internal-metadata__form-config">
		<mat-form-field [appearance]="Appearance">
			<mat-label
				i18n="@@subscription.internalMetadata.form.label">
				label</mat-label>
			<input
				type="text"
				id="{{ cmpId + '-label-input' }}"
				matInput
				[formControlName]="InternalMetadataFormControls.Label" />
			<mat-hint [align]="'end'">
				{{
					internalMetadataForm.form
						.get(InternalMetadataFormControls.Label)?.value?.length || 0
				}}/{{Configuration.maxLengthLabel}}
			</mat-hint>
			<mat-error
				*ngIf="
					internalMetadataForm.form
						.get(InternalMetadataFormControls.Label)
						?.hasError(ValidationErrorKeys.Maxlength)
				"
				i18n="@@general.form.errors.maxlength">
				max length
			</mat-error>
			<mat-error
				*ngIf="
					internalMetadataForm.form
						.get(InternalMetadataFormControls.Label)
						?.hasError(ValidationErrorKeys.Pattern)
				"
				i18n="@@general.form.errors.unauthorizedCharacters">
				unauthorized-characters
			</mat-error>
			<mat-error
				*ngIf="
					internalMetadataForm.form
						.get(InternalMetadataFormControls.Label)
						?.hasError(ValidationErrorKeys.Required)
				"
				i18n="@@general.form.errors.required">
				max length
			</mat-error>
		</mat-form-field>
		<mat-form-field [appearance]="Appearance">
			<mat-label
				i18n="@@subscription.internalMetadata.form.description">
				description
			</mat-label>
			<textarea
				type="text"
				[rows]="4"
				id="{{ cmpId + '-description-input' }}"
				matInput
				[formControlName]="InternalMetadataFormControls.Description"></textarea>
			<mat-hint [align]="'end'">
				{{
					internalMetadataForm.form
						.get(InternalMetadataFormControls.Description)?.value?.length || 0
				}}/{{Configuration.maxLengthDescription}}
			</mat-hint>
			<mat-error
				*ngIf="
					internalMetadataForm.form
						.get(InternalMetadataFormControls.Description)
						?.hasError(ValidationErrorKeys.Maxlength)
				"
				i18n="@@general.form.errors.maxlength">
				max length
			</mat-error>
		</mat-form-field>

		<app-tag-configurator
			displayMode="tags"
			configMode="ActiveEdit"
			(hasChangedValue)="hasTagsChanged()"
			[configuredTags]="vo.internalMetadata.tags | toArray"
			[availableTags]="vo.availableTags | toArray"></app-tag-configurator>

		<app-image-picker [selection]="vo.internalMetadata.picId" [images]="vo.availablePics" [startOpen]="false"
											(selectedPic)="onPicSelection($event)"></app-image-picker>
	</form>

	<div
		*ngIf="vo.isInViewMode"
		class="subscription-internal-metadata__view-mode">
		<!-- LABEL -->
		<div>
			<span
				[matTooltip]="vo.internalMetadata.label"
				[matTooltipDisabled]="vo.internalMetadata.label.length <= Configuration.maxLengthSubMetadataTitleDisplay"
				matTooltipPosition="right">
				{{vo.internalMetadata.label | truncate: Configuration.maxLengthSubMetadataTitleDisplay : 2 : 'end'}}</span>
		</div>

		<!-- DESCRIPTION -->
		<div *ngIf="vo.internalMetadata.description">
			<span
				[matTooltip]="vo.internalMetadata.description"
				[matTooltipDisabled]="vo.internalMetadata.description.length <= Configuration.maxLengthSubMetadataDescriptionDisplay"
				matTooltipPosition="right">
				{{vo.internalMetadata.description | truncate: Configuration.maxLengthSubMetadataDescriptionDisplay : 5 : 'end'}}</span>
		</div>

		<!-- TAGS -->
		<div *ngIf="vo.internalMetadata.tags.size !== 0">
			<app-tag-configurator
				displayMode="tags"
				configMode="View"
				[configuredTags]="vo.internalMetadata.tags | toArray">
			</app-tag-configurator>
		</div>
	</div>
</div>
